import { render } from "./Index.vue?vue&type=template&id=061d4446&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=061d4446&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-061d4446"

export default script